export default [
  'Solteiro',
  'Casado',
  'Separado Judicialmente',
  'Divorciado',
  'Viúvo',
];
